(function () {
  'use strict';
  var pending = new Map();
  function load(template) {
    if (pending.has(template)) return pending.get(template);
    var node = template.content.firstElementChild.cloneNode(true);
    var request = new Promise(function(resolve, reject) {
      node.onload = function() {template.dataset.shLoaded='true';resolve();};
      node.onerror = function() { pending.delete(template); node.remove(); reject(new Error('Optional resource unavailable')); };
      template.parentNode.insertBefore(node, template);
    });
    pending.set(template, request);
    return request;
  }
  var searchReady = false;
  var searchRequest;
  function search() {
    if (searchReady) return Promise.resolve();
    if (searchRequest) return searchRequest;
    searchRequest = Promise.all(Array.from(document.querySelectorAll('template[data-sh-search-resource]')).map(load)).then(function() {searchReady=true;}).catch(function(error) {searchRequest=null;throw error;});
    return searchRequest;
  }
  var collections = [];
  function collection(entry) {
    if (entry.ready) return Promise.resolve();
    return load(entry.template).then(function() {entry.ready=true;});
  }
  function searchTrigger(target) {return target.closest && target.closest('.js-search-header,.site-header a[href*="/search"],[data-sh-search-trigger]');}
  function warm(event) {
    if (searchTrigger(event.target)) search().catch(function() {});
    var quick=event.target.closest && event.target.closest('[data-sh-quick],[data-sh-uc-quick]');
    var section=quick && quick.closest('.shopify-section');
    if(section)section.querySelectorAll('template[data-sh-quick-resource]').forEach(function(t){load(t).catch(function(){});});
    collections.forEach(function(entry) {if (entry.root.contains(event.target) && event.target.closest('button,input,select')) collection(entry).catch(function() {});});
  }
  ['pointerover','focusin','touchstart'].forEach(function(type) {document.addEventListener(type,warm,{capture:true,passive:true});});
  window.addEventListener('click', function(event) {
    var trigger = searchTrigger(event.target);
    var entry = collections.find(function(item) {return !item.ready && item.root.contains(event.target) && event.target.closest('button');});
    var quick=event.target.closest && event.target.closest('[data-sh-quick],[data-sh-uc-quick]');
    var section=quick && quick.closest('.shopify-section');
    var styles=section ? Array.from(section.querySelectorAll('template[data-sh-quick-resource]')).filter(function(t){return t.dataset.shLoaded!=='true';}) : [];
    if ((!trigger || searchReady) && !entry && !styles.length) return;
    var control = trigger || event.target.closest('button');
    var oldCard = control.closest('[data-product-handle],[data-sh-card]');
    var handle = oldCard && (oldCard.dataset.productHandle || oldCard.dataset.shCard);
    var label = control.getAttribute('aria-label');
    event.preventDefault(); event.stopImmediatePropagation();
    if (control.getAttribute('aria-busy') === 'true') return;
    control.setAttribute('aria-busy','true');
    Promise.all([trigger ? search() : entry ? collection(entry) : Promise.resolve()].concat(styles.map(load))).then(function() {
      control.removeAttribute('aria-busy');
      var target = control;
      if (!target.isConnected && entry && handle) {
        var card = entry.root.querySelector('[data-sh-card="'+CSS.escape(handle)+'"],[data-product-handle="'+CSS.escape(handle)+'"]');
        target = label && card ? card.querySelector('[aria-label="'+CSS.escape(label)+'"]') : null;
        if (!target && (!label || /quick|add/i.test(label))) target = entry.root.querySelector('[data-sh-quick="'+CSS.escape(handle)+'"]');
      }
      if(target && target.isConnected) target.click();
    }).catch(function() {
      control.removeAttribute('aria-busy');
      if(trigger && trigger.href) location.assign(trigger.href);
    });
  },true);
  function boot() {
    document.querySelectorAll('template[data-sh-media-resource]').forEach(function(template) {
      if(template.dataset.shObserved)return;
      template.dataset.shObserved='true';
      var query=matchMedia(template.dataset.shMediaResource);
      function sync() {if(query.matches)load(template).catch(function() {});}
      sync();
      if(query.addEventListener)query.addEventListener('change',sync);
    });
    document.querySelectorAll('template[data-sh-collection-resource]').forEach(function(template) {
      if(template.dataset.shObserved)return;
      var section=template.closest('.shopify-section');
      var root=section && section.querySelector('section') || section;
      if(!root)return;
      template.dataset.shObserved='true';
      var entry={template:template,root:root,ready:false};collections.push(entry);
      var grid=root.querySelector('[data-sh-product-grid]') || root;
      if('IntersectionObserver' in window) {
        var observer=new IntersectionObserver(function(entries) {if(entries.some(function(e){return e.isIntersecting;})){observer.disconnect();collection(entry).catch(function() {});}},{rootMargin:'300px 0px'});
        observer.observe(grid);
      } else collection(entry).catch(function() {});
      if(window.Shopify && Shopify.designMode)collection(entry).catch(function() {});
    });
  }
  document.addEventListener('predictive-search:open',function(){search().catch(function(){});});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('shopify:section:load',boot);
}());
